import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import washService from "../../../../services/wash.service";
import { IWashRequest } from "../../../../types/wash.types";
import WashHistoryTable from "../../../../components/WashHistoryTable/WashHistoryTable";

const WashingHistory = () => {
  const { t } = useTranslation();
  const { carWashID } = useParams<{ carWashID: string }>();
  const [washes, setWashes] = useState<IWashRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!carWashID) return;
    setLoading(true);
    setError(null);
    washService
      .getCarWashWashes(carWashID)
      .then((data) => setWashes(data))
      .catch((err: any) => setError(err.message || t("washingHistory.loadFailed")))
      .finally(() => setLoading(false));
    // Re-runs only when carWashID changes; `t` changes identity on
    // language switch, and re-running this fetch because the UI language
    // changed is not wanted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carWashID]);

  return (
    <Box p={3}>
      <WashHistoryTable
        washes={washes}
        loading={loading}
        error={error}
        onDismissError={() => setError(null)}
        title={t("carWashes.tabWashingHistory")}
        emptyMessage={t("washingHistory.emptyForCarWash")}
        showCustomer
      />
    </Box>
  );
};

export default WashingHistory;
